(function () {
  if (window.QLSShippingProtectionLoaderInstalled) return;
  window.QLSShippingProtectionLoaderInstalled = true;

  var configNode = document.querySelector('[data-qls-shipping-protection-config]');
  if (!configNode || configNode.dataset.enabled !== 'true') return;

  var scriptUrl = configNode.dataset.scriptSrc;
  if (!scriptUrl) return;

  var loading = false;
  var loaded = false;
  var cartIntentSelector = [
    'a[href*="/cart"]',
    'button[name="add"]',
    '[name="add"]',
    '.js-quick-add',
    '[data-product-url]',
    '[data-cart-drawer]',
    '[aria-controls*="cart"]',
    'cart-drawer',
    'cart-notification'
  ].join(',');

  function loadCompatibilityController() {
    if (loaded || loading) return;
    loading = true;

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;
    script.setAttribute('data-qls-shipping-protection-controller', 'true');
    script.onload = function () {
      loaded = true;
      loading = false;
      document.dispatchEvent(new CustomEvent('qls:shipping-protection-controller-ready'));
    };
    script.onerror = function () {
      loading = false;
    };
    document.head.appendChild(script);
  }

  function handleIntent(event) {
    var target = event && event.target;
    if (target && target.closest && target.closest(cartIntentSelector)) {
      loadCompatibilityController();
    }
  }

  document.addEventListener('pointerdown', handleIntent, true);
  document.addEventListener('click', handleIntent, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action = form && form.getAttribute ? String(form.getAttribute('action') || '').toLowerCase() : '';
    if (action.indexOf('/cart/add') !== -1) loadCompatibilityController();
  }, true);

  [
    'cart:open',
    'cart:refresh',
    'cart:updated',
    'cart:change',
    'theme:cart:change',
    'ajaxProduct:added',
    'on:cart:add'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, loadCompatibilityController, true);
  });

  if (String(window.location.pathname || '').toLowerCase().indexOf('/cart') === 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadCompatibilityController, { once: true });
    } else {
      loadCompatibilityController();
    }
  }
})();
